import classNames from 'classnames';
import { FC, HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

import css from './form-input-wrapper.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement>, PropsWithChildren {
  label?: ReactNode;
  required?: boolean;
  marginBottomNone?: boolean;
  disabled?: boolean;
  labelClassName?: string;
}

const FormInputWrapper: FC<Props> = ({
  label,
  required = false,
  marginBottomNone = false,
  disabled = false,
  className,
  labelClassName,
  children,
  ...rest
}) => {
  return (
    <div
      className={classNames(
        css.formInput,
        'form-input',
        {
          'form-input_margin-bottom-none': marginBottomNone,
          required,
          [css.disabled]: disabled,
        },
        className,
      )}
      {...rest}
    >
      {label && <div className={classNames(css.formInputLabel, 'form-input__label', labelClassName)}>{label}</div>}
      {children}
    </div>
  );
};

export default FormInputWrapper;
